<mat-form-field appearance="fill">
  <mat-label>{{'common.language' | translate}}</mat-label>
  <mat-select (selectionChange)="changeLanguage($event)">
    <mat-option value="it">IT</mat-option>
    <mat-option value="en">EN</mat-option>
  </mat-select>
</mat-form-field>
